import React from 'react';
import styled from 'styled-components';
import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { goToNextState } from '../../../helpers/goToNextState';
import { goToPreviousState } from '../../../helpers/goToPreviousState';
import { isFinalState } from '../../../helpers/isFinalState';
import { isInitialState } from '../../../helpers/isInitialState';
import { stateHasValue } from '../../../helpers/stateHasValue';
import { ArrowLeft, ArrowRight } from '../../../components/Icon';
import { isCurrentState } from '../../../helpers/isCurrentState';

const StyledButtonsWrpper = styled.div`
  width: auto;
  display: flex;
  justify-content: space-between;
  position: relative;
  align-items: center;
  overflow: visible;
  bottom: 16px;
  
  @media (min-width: 768px) {
    display: none;
  }
`;

const StyledButton = styled.div<{ disabled?: boolean }>`
  width: 44px;
  z-index: 9;
  padding: 0;
  border: none;
  display: block;
  cursor: ${({ disabled }) => {
    return disabled ? `not-allowed; opacity: 0.5;` : `pointer`;
  }};

  
  @media (max-width: 767px) {
    position: absolute;
    top: 32%;
    z-index: 5;
    left: 0;
    transform: translateY(-94%);

    &:nth-child(2) {
      margin-top: -3px;
      right: 0;
      left: auto;
    }
  }
`;

interface NavigationSmallProps {
  onBackClick?: () => void;
}

export const NavigationSmall: React.FC<NavigationSmallProps> = ({ onBackClick }) => {
  const [state, send] = useService(productBuilderMachine);

  const smartReleaseStateStatus =
    isCurrentState('smartRelease', state) &&
    typeof state.context.custom.smartRelease === 'string' &&
    state.context.custom.smartRelease !== 'no';

  const handleBackClick = () => {
    // Call the parent callback if provided
    if (onBackClick) {
      onBackClick();
    }
    // Execute the original back navigation
    goToPreviousState(state, send)();
  };

  return (
    <StyledButtonsWrpper>
      <StyledButton
        onClick={handleBackClick}
        disabled={isInitialState(state)}
      >
        <ArrowLeft />
      </StyledButton>
      <StyledButton
        onClick={goToNextState(state, send)}
        disabled={
          isFinalState(state) ||
          !stateHasValue(state) ||
          smartReleaseStateStatus ||
          state.matches('measurements.loading') ||
          state.matches('measurements.failure')
        }
      >
        <ArrowRight />
      </StyledButton>
    </StyledButtonsWrpper>
  );
};
